/** LCM API success code. */
export function isApiSuccessCode(code: unknown): boolean {
  return code === 200 || code === "200";
}

function readTaskIdFromRecord(
  record: Record<string, unknown>,
): string | undefined {
  const candidates = [
    record.asyncKey,
    record.async_key,
    record.taskId,
    record.task_id,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) return value.trim();
    if (typeof value === "number" && Number.isFinite(value)) {
      return String(value);
    }
  }
  return undefined;
}

/**
 * Resolves async task id from PUT /lifecycles or GET /async/tasks responses.
 * Supports wrapped { code, data } and unwrapped payloads.
 */
export function resolveAsyncTaskKey(
  res: Record<string, unknown> | null | undefined,
): string | undefined {
  if (!res) return undefined;

  const data = res.data;
  if (typeof data === "string" && data.trim()) return data.trim();
  if (typeof data === "number" && Number.isFinite(data)) return String(data);
  if (data && typeof data === "object" && !Array.isArray(data)) {
    const fromData = readTaskIdFromRecord(data as Record<string, unknown>);
    if (fromData) return fromData;
  }

  return readTaskIdFromRecord(res);
}

export function isLifecycleUpdateSuccess(
  res: Record<string, unknown> | null | undefined,
): boolean {
  if (!res) return false;
  if (isApiSuccessCode(res.code)) return true;
  return !!resolveAsyncTaskKey(res);
}

export function parseAsyncTaskPollPayload(
  res: unknown,
): { status?: string; message?: string } | null {
  if (!res || typeof res !== "object") return null;

  const record = res as Record<string, unknown>;
  const payload =
    record.data && typeof record.data === "object" && !Array.isArray(record.data)
      ? (record.data as Record<string, unknown>)
      : record;

  const status = payload.status;
  const message = payload.message;

  if (typeof status !== "string" && typeof status !== "number") {
    if (!isApiSuccessCode(record.code)) return null;
    return null;
  }

  return {
    status: String(status),
    message: typeof message === "string" ? message : undefined,
  };
}
